import React from 'react';

import './PageTitle.scss';

export default function PageTitle({ title, isOffWhite }: { title: string, isOffWhite?: boolean }) {
  return <div className={`page-title`}>
    <div className="title">{title}</div>
    <div className={`divider ${isOffWhite ? 'off-white' : 'white'}`} />
  </div>
}